document.addEventListener('DOMContentLoaded', () => {

  const placeholders = document.querySelectorAll(
    '.media-feed-pro__video-placeholder'
  );

  placeholders.forEach((placeholder) => {

    placeholder.addEventListener('click', () => {

      if (placeholder.classList.contains('is-loaded')) return;

      const type = placeholder.dataset.type;
      const videoId = placeholder.dataset.videoId;

      let iframeSrc = '';

      if (type === 'youtube') {

        iframeSrc =
          `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0&modestbranding=1`;

      } else if (type === 'vimeo') {

        iframeSrc =
          `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1`;

      }

      const iframe = document.createElement('iframe');

      iframe.src = iframeSrc;
      iframe.allow =
        'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';

      iframe.allowFullscreen = true;

      iframe.className = 'media-feed-pro__iframe';

      placeholder.innerHTML = '';
      placeholder.appendChild(iframe);

      placeholder.classList.add('is-loaded');

    });

  });

});